/**
 * Centralized redirect rules used by both SSR (Node) and the dev proxy (TS).
 *
 * IMPORTANT: Paths starting with /s/SLT/ go directly to SFCC and bypass the PWA server.
 * Redirects for /s/SLT/ paths must be configured in SFCC Business Manager, not here.
 * These rules will only work for paths that reach the PWA server.
 *
 * @typedef {Object} RedirectRule
 * @property {string|RegExp} from - The URL path to match (can be a string or RegExp)
 * @property {string} to - The destination path (must be a relative URL starting with /)
 * @property {number} [code] - HTTP redirect status code (defaults to 302 if not specified)
 *
 * @type {RedirectRule[]}
 */
module.exports = [
    { from: '/gift-card-balance', to: '/gifts/gift-cards', code: 301 },
    // Note: /s/SLT/ paths must be configured in SFCC Business Manager
    // These regex patterns work for paths that don't start with /s/SLT/ (e.g., direct /recipe/ URLs)
    { from: /^(?:\/s\/SLT)?\/([^/]+)\/REC-(\d+)\.html$/, to: '/recipe/$1/REC-$2', code: 301 },
    { from: /^\/s\/SLT\/recipes\/?$/, to: '/recipes', code: 301 }, // Must be configured in SFCC BM
    { from: /^(?:\/s\/SLT)?\/([^/]+)\/PROD-(\d+)\.html$/, to: '/product/$1/PROD-$2', code: 301 },
    { from: /^\/s\/SLT\/products\/?$/, to: '/products', code: 301 }, // Must be configured in SFCC BM
];
